import { render, staticRenderFns } from "./PaymentsRadioField.vue?vue&type=template&id=481f7351&"
import script from "./PaymentsRadioField.vue?vue&type=script&lang=js&"
export * from "./PaymentsRadioField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports